<template>
  <v-container>
    <v-layout text-center justify-center wrap>
      <v-flex xs12 my-5 title>TOC-generator</v-flex>
      <v-flex xs12>
        <v-text-field
          outlined
          @input="generateToc"
          v-model="url"
          placeholder="Collez ici l'URL de la preview"
          label="URL de la preview"
        ></v-text-field>
      </v-flex>

      <v-flex xs12 mb-4>
        <prism-editor :code="toc" language="html" :readonly="true"></prism-editor>
      </v-flex>
    </v-layout>
    <v-snackbar v-model="snackbar" :top="true" :right="true">
      {{ text }}
      <v-btn color="pink" text @click="snackbar = false">Fermer</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import axios from "axios";
import { html as beautify } from "js-beautify";
import PrismEditor from "vue-prism-editor";
import { detect } from "detect-browser";

export default {
  components: {
    PrismEditor
  },
  data: () => ({
    url: "",
    toc: "",
    text: "",
    error: "",
    snackbar: false
  }),
  watch: {
    url: function() {
      if (this.url === "") {
        this.toc = "";
      }
    }
  },
  methods: {
    copyTextAsync: function() {
      return new Promise(resolve => {
        this.$copyText(this.toc).then(
          function() {
            resolve({
              snackbar: true,
              text: "Table des matières copiée dans le presse-papier."
            });
          },
          function() {
            alert("Can not copy");
          }
        );
      });
    },
    doCopy: async function() {
      const { snackbar, text } = await this.copyTextAsync();
      this.snackbar = snackbar;
      this.text = text;
    },
    generateToc: async function() {
      this.toc = "Génération de la table des matières...";
      if (this.url.length) {
        try {
          const { data } = await axios({
            method: "get",
            url: `/.netlify/functions/generate-toc?url=${this.url}`
          });
          this.toc = beautify(data.toc);
          const browser = detect();
          if (browser && browser.name === "chrome") {
            this.doCopy();
          }
        } catch (e) {
          this.toc =
            "Erreur lors de la génération, veuillez verifier votre URL.";
        }
      }
    }
  }
};
</script>

<style>
code {
  box-shadow: none !important;
}
</style>
